const csvTemplate = `reference_ean,quantity,taxes.type
CRS.SC-CSSUPM701,2,inc
DA.SC-ACIGALL1,2,inc
DE.SC-APM18ALL1,2,inc
RJK.SC-PPEIM251,5,inc
AU.SC-ADMTTM7ALL1,6,inc
AU.SC-ADMLN7ALL1,2,inc
CRS.SC-CSSUPM701,2,inc
CX.SC-LGMC1501,2,inc
4719745010293,2,inc
4719745505119,2,inc`;

export default csvTemplate;
